import { Link } from "react-router-dom";

const logos = [
  { id: 1, name: "Tabs stack + arrow", desc: "Stack d'onglets archives avec flèche express. Très lisible, sens immédiat." },
  { id: 2, name: "Box + motion lines", desc: "Carton d'archive + lignes de vitesse. Évoque enlèvement rapide." },
  { id: 3, name: "Monogram A badge", desc: "Badge premium avec monogramme A. Très corporate, premium." },
  { id: 4, name: "Shield + documents", desc: "Bouclier + lignes de documents. Confidentialité & sécurité au cœur." },
  { id: 5, name: "Typographic X", desc: "Pur wordmark avec X stylisé. Style Stripe/Linear, minimaliste premium." },
];

export default function LogoPreview() {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600">Sélection logo</div>
            <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-slate-950 mt-2">
              5 propositions ArchivExpress
            </h1>
            <p className="text-slate-600 mt-3">Cliquez sur celui que vous préférez (ou indiquez-moi le numéro).</p>
          </div>
          <Link to="/" className="text-sm font-semibold text-slate-700 hover:text-blue-600" data-testid="back-link">← Retour landing</Link>
        </div>

        <div className="space-y-5">
          {logos.map((l) => (
            <div key={l.id} className="bg-white rounded-2xl border border-slate-200 overflow-hidden" data-testid={`logo-row-${l.id}`}>
              <div className="grid grid-cols-1 md:grid-cols-2">
                {/* Light variant */}
                <div className="p-10 flex items-center justify-center bg-white border-r border-slate-100">
                  <img src={`/logos/archivexpress-${l.id}.svg`} alt={`Logo ${l.id}`} className="h-16" />
                </div>
                {/* Dark variant */}
                <div className="p-10 flex items-center justify-center bg-slate-950">
                  <img src={`/logos/archivexpress-${l.id}.svg`} alt={`Logo ${l.id} dark`} className="h-16 brightness-0 invert" />
                </div>
              </div>
              <div className="px-6 py-5 border-t border-slate-100 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <div>
                  <div className="font-display text-lg font-bold text-slate-950">#{l.id} — {l.name}</div>
                  <div className="text-sm text-slate-600">{l.desc}</div>
                </div>
                <a
                  href={`/logos/archivexpress-${l.id}.svg`}
                  download
                  className="inline-flex items-center justify-center px-4 py-2 rounded-full bg-slate-950 text-white text-xs font-bold hover:bg-blue-600 transition-colors"
                  data-testid={`logo-download-${l.id}`}
                >
                  Télécharger SVG
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 p-6 rounded-2xl bg-blue-50 border border-blue-200 text-sm text-slate-700">
          Indiquez-moi simplement le numéro (1 à 5) du logo que vous préférez, je l'applique partout sur la landing page.
        </div>
      </div>
    </div>
  );
}
